<template>
    <section class="mbs-wrap mbs020 mbs025">
        <div class="mbs-inner clear">
            <LoginLeft/>
            <div class="mbs-right" v-if="isCertification === false && isModify === false">
                <div class="tit">{{ $i18nUtil.trans("title.cowork", "업무공유시스템") }}</div>
                <div class="txt" v-html="$i18nUtil.trans('message.IntegrateReLogin.001', '정보 보호를 위하여 연결이 종료되었습니다.<br>재 로그인 후 사용해주세요.')"></div>
                <fieldset>
                    <div class="input-box">
                        <input
                            type="text"
                            id="userId"
                            name="userId"
                            v-validate="'required'"
                            v-model="userId"
                            :placeholder="$i18nUtil.trans('message.IntegrateLogin.001', '아이디 또는 이메일')"
                            @focus="$event.target.placeholder=''"
                            @focusout="$event.target.placeholder=$i18nUtil.trans('message.IntegrateLogin.001', '아이디 또는 이메일')"
                        />
                        <div class="error" v-show="errors.has('userId')">{{ $i18nUtil.trans("UB029", "아이디 또는 이메일을 입력해주세요.") }}</div>
                    </div>
                    <div class="input-box">
                        <input
                            type="password"
                            id="password"
                            name="password"
                            v-validate="'required'"
                            v-model="password"
                            :placeholder="$i18nUtil.trans('message.placeholder.password', '비밀번호')"
                            @focus="$event.target.placeholder=''"
                            @focusout="$event.target.placeholder=$i18nUtil.trans('message.placeholder.password', '비밀번호')"
                        />
                        <div class="error" v-show="errors.has('password')">{{ $i18nUtil.trans("UB028", "비밀번호를 입력해주세요.") }}</div>
                    </div>
                    <div class="info-txt">{{ $i18nUtil.trans("message.IntegrateLogin.005", "* 내부 직원은 서클 아이디를 사용하여 로그인 하시기 바랍니다.") }}</div>
                    <button type="button" class="btn_login" v-if="ssoUse" @click="loginSSO">Login</button>
                    <button type="button" class="btn_login" v-else @click="handleLogin">{{ $i18nUtil.trans("button.login", "로그인") }}</button>
                </fieldset>
                <div class="logo_area clear" v-if="!isDef">
                    <div class="lifeplus_logo">LIFE PLUS</div>
                    <div class="hw_logo">한화생명</div>
                </div>
            </div>

            <!-- 외부망 2 factor 인증 -->
            <div class="mbs-right" v-if="isCertification === true && isModify === false">
                <div class="tit">{{ $i18nUtil.trans("title.cowork", "업무공유시스템") }}</div>
                <div class="txt" v-html="$i18nUtil.trans('message.IntegrateLogin.006', '업무공유시스템(외부)에서는 사내 보안규정 준수를<br>위해 로그인 시 인증이 필요합니다.')"></div>
                <fieldset v-show="!otpInputField">
                    <div class="radio-box" v-if="accessDevice === false">
                        <!-- 모바일 앱 인증 기기 X : 인증번호 요청 버튼만 노출 -->
                        <button type="button" class="btn_login" @click="produceOtp" :style="$i18nUtil.getLanguage() === 'en' ? 'font-size: 15px;' : ''">
                            {{ $i18nUtil.trans("button.CheckOtp.produce.SMS", "SMS 인증번호 요청") }}
                        </button>
                    </div>
                    <div class="radio-box" v-if="accessDevice === true">
                        <!-- 모바일 앱 인증 기기 O : SMS OR 모바일앱 라디오 버튼 + 인증번호 요청 버튼 노출 -->
                        <input type="radio" id="mob" value="MOB" v-model="type"><label for="mob">{{ $i18nUtil.trans("button.radio.mobileApp", "모바일앱") }}</label>
                        <input type="radio" id="sms" value="SMS" v-model="type"><label for="sms">SMS</label>
                    </div>
                    <button type="button" class="btn_login" @click="produceOtp" v-if="accessDevice === true"
                        v-html="$i18nUtil.trans('button.UserCheck.req.otp', '인증번호 요청')"
                    >
                    </button>
                </fieldset>

                <!-- 인증번호 입력 창 시작 -->
                <fieldset v-show="otpInputField">
                    <div class="input-box">
                        <input
                            type="number"
                            id="otp"
                            name="otp"
                            v-model="otp"
                            v-validate="'required'"
                            :placeholder="$i18nUtil.trans('message.placeholder.otp', '인증번호')"
                            @focus="$event.target.placeholder=''"
                            @focusout="$event.target.placeholder=$i18nUtil.trans('message.placeholder.otp', '인증번호')"
                            maxlength="6"
                            oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                        />
                        <span class="time" v-if="countDown !== null" :style="$i18nUtil.getLanguage() === 'en' ? 'right: 110px;' : ''">
                            <span>{{ countDown }}</span>
                        </span>
                        <!-- 2021-09-09 전송 버튼 삭제 & 재전송 -> 재요청 기능 변경 및 버튼명 변경 -->
                        <button type="button" class="btn-primary-small" @click="reProduceOtp()">{{ $i18nUtil.trans("button.re.req", "재요청") }}</button>
                        <!-- <button type="button" class="btn-primary-small black" v-if="isFirst === true" @click="produceOtp">{{ $i18nUtil.trans("button.send", "전송") }}</button>
                        <button type="button" class="btn-primary-small black" v-if="isFirst === false" @click="produceOtp">{{ $i18nUtil.trans("button.re.send", "재전송") }}</button> -->
                        <div class="error" v-if="errors.has('otp') || otpEmpty">{{ $i18nUtil.trans("UB044", "인증번호를 입력해주세요.") }}</div>
                    </div>
                    <div class="certification-txt">{{ $i18nUtil.trans("message.IntegrateLogin.012", "* 모바일 폰에서 발급받은 인증번호를 입력 후 진행해주세요.") }}</div>
                    <button type="button" class="btn_login" @click="compareOtp">{{ $i18nUtil.trans("button.confirm", "확인") }}</button>
                </fieldset>
                <!-- 인증번호 입력 창 끝 -->

                <div class="logo_area clear" v-if="!isDef">
                    <div class="lifeplus_logo">LIFE PLUS</div>
                    <div class="hw_logo">한화생명</div>
                </div>
            </div>
            <div v-if="isModify === true">
                <ModifyPassword :userId="userId" :cellPhoneNo="cellPhoneNo" @successModify="successModify"/>
            </div>
        </div>
        <form ref="SSO_LOGIN">
            <input type="hidden" name=USER v-model="userId"/>
            <input type="hidden" name=PASSWORD v-model="password"/>
            <input type="hidden" name=SMAUTHREASON value="0">
            <input type="hidden" name=TARGET value="">
            <input type="hidden" name=SMAGENTNAME value="">
        </form>
        <MainFooter/>
        <modals-container @dialogConfirm="dialogConfirm" @validOtp="validOtp"/>
    </section>
</template>

<script>
import LoginLeft from "../base/LoginLeft";
import UserCheck from "../modal/UserCheck";
import ModifyPassword from "./ModifyPassword";
import Dialog from "@/components/cowork/common/alertMessage/Dialog";
import MainFooter from "@/components/cowork/general/main/MainFooter";
import { mapState, mapActions } from "vuex";
//import "../../../../assets/css/login.css";
export default {
    components: {
        Dialog,
        LoginLeft,
        MainFooter,
        UserCheck,
        ModifyPassword
    },
    data() {
        return {
            type : "SMS",
            // isFirst : true,
            userId : "",
            password : "",
            cellPhoneNo : "",
            isValidOtp : false,
            isModify : false,
            isCertification : false,
            accessDevice : null,
            /* 타이머 설정 값 */
            minutes: 0,
            secondes: 0,
            time: 300,
            timer: null,
            /* OTP 인증 설정 값 */
            otp : "",
            otpId : null,
            resOtp: "",
            /* 브라우저 locale */
            browserLocale: null,
            domain : null,
            isDef : null,
            ssoUse : false,
            otpInputField: false,
            otpEmpty: false,
        }
    },
    created() {
        this.handleInit();
        this.isSsoCheck();
    },
    mounted() {
        this.isDefCheck();
        let obj = this;
        //window.addEventListener('keyup', function(event) {
        //    if (event.keyCode === 13 && !obj.isCertification && !obj.isModify) { 
        //        obj.handleLogin();
        //    }
        //});
        window.addEventListener('keyup', obj.chkEnter);
    },
    beforeDestroy() {
        let obj = this;
        window.removeEventListener('keyup', obj.chkEnter);
    },
    watch: {
        otp: function() {
            this.otp.length > 0 ? this.otpEmpty = false : true;
        }
    },
    computed: {
        /* OTP 인증 시간 */
        countDown() {
            let time = this.time / 60;
            let minutes = parseInt(time);
            let secondes = Math.round((time - minutes) * 60);

            let min = minutes;
            let sec = secondes;
            if (min < 10) {
                min = "0" + min;
            }
            if (sec < 10) {
                sec = "0" + sec;
            }
            return min + " : " + sec;
        }
    },
    methods: {
        ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
        ...mapActions("modals", ["showDialog", "showModal"]),
        isDefCheck() {
            this.domain = location.host;
            if(this.domain.indexOf("def")) {
                this.isDef = false;
            } else {
                this.isDef = true;
            }
        },
        chkEnter(event) { // 이벤트리스너 제거하기 위해 함수로 정의
            let obj = this;
            if (event.keyCode === 13 && !obj.isCertification && !obj.isModify) {
                if(location.host.indexOf("hanwhalife.com") > -1 && location.host != "cpdev.hanwhalife.com"){
                    obj.loginSSO();
                } else {
                    obj.handleLogin();
                }
            }
        },
        /* 다국어 & 망구분(내/외/모바일) */
        handleInit() {
            let obj = this;
            /* 다국어 설정(브라우저 언어 별) */
            let locale = navigator.language || navigator.userLanguage;
            locale = locale.substring(0, 2);
            if (locale !== "ko") {
                locale = "en";
            }
            localStorage.setItem('defaultLanguage', locale); // 다국어 디폴트 설정으로 로그인 페이지에서 브라우저 언어를 따라가지 않아 설정
            obj.browserLocale = locale;
            obj.$i18n.locale = locale;            
        },
        /* 로그인 */
        handleLogin() {
            this.$validator.validate().then(valid => {
                if(valid) {
                    let obj = this;
                    let reqData = {
                        url: "/api/auth/intergrateLogin",
                        method: "post",
                        params: {
                            userId: obj.userId,
                            password: obj.password,
                            domain : obj.domain,
                        }
                    };                  
                    obj
                    .COWORK_REST_SIMPLE_ACTION(reqData)
                    .then(function(res) {
                        let errorCode = res.errorCode;
                        if(errorCode != null && errorCode != undefined) {
                            let contents = null;
                            let info = {
                                title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                                button: obj.$i18nUtil.trans("button.dialog.confirm", "확인"),
                                contents : contents
                            };
                            if(errorCode === "AG006") {
                                /* 사용자 비밀번호 오류 시 */
                                info.width = "350px";
                                info.contents = obj.$i18nUtil.trans("AG006", "아이디 또는 비밀번호를 잘못 입력하셨습니다.\n동일 계정 5회 이상 로그인 실패 시 계정 잠금 상태로 전환됩니다.");
                                obj.handleDialog(info);
                            } else if(errorCode === "AG007") {
                                /* 서클 사용자 비밀번호 5회 오류 시 */
                                info.width = "350px";
                                // info.height = "180px";
                                info.contents = obj.$i18nUtil.trans("AG007", "동일 계정 5회 이상 로그인 실패하여 계정 잠금 상태로 전환되었습니다.\n서클에서 비밀번호를 재발급하시기 바랍니다.");
                                obj.handleDialog(info);
                            } else if(errorCode === "AG023") {
                                /* 외부 사용자 비밀번호 오류 시 */
                                info.contents = obj.$i18nUtil.trans("AG023", "아이디(이메일) 또는 비밀번호를 잘못 입력하셨습니다.\n동일 계정 5회 이상 로그인 실패 시 계정 잠금 상태로 전환됩니다.");
                                obj.handleDialog(info);
                            } else if(errorCode === "AG024") {
                                /* 외부 사용자 비밀번호 5회 오류 시 */
                                info.width = "350px";
                                // info.height = "180px";
                                info.renewal = "RENEWAL";
                                info.contents = obj.$i18nUtil.trans("AG024", "동일 계정 5회 이상 로그인 실패하여 계정 잠금 상태로 전환되었습니다.\n사용자 인증 후 비밀번호를 재설정 해주시기 바랍니다.");
                                obj.handleDialog(info);
                                //obj.RenewalPasswordPop();
                            } else if(errorCode === "AG020") {
                                /* 비밀번호 유효기간 만료 시 */
                                info.contents = obj.$i18nUtil.trans("AG020", "비밀번호 유효기간이 만료되었습니다.\n서클에서 비밀번호 변경 후 다시 로그인해주세요.");
                                obj.handleDialog(info);
                            } else if(errorCode === "AG019") {
                                /* 휴면계정 처리 시 */
                                info.contents = obj.$i18nUtil.trans("AG019", "휴면계정 처리되었습니다.\n서클에서 휴면계정 해지 후 다시 로그인해주세요.");
                                obj.handleDialog(info);
                            } else if(errorCode === "AG019.001") {
                                /* 201 휴면계정 처리 시 */
                                info.contents = obj.$i18nUtil.trans("AG019.001", "휴면계정 처리되었습니다.\n휴면해지를 위해 사용자 인증을 진행해 주십시오.");
                                obj.handleDialog(info);
                                obj.dormantYn = true;
                                obj.accessDevice = false;
                            } else if(errorCode === "AG028") {
                                /* 비밀번호 유효기간이 만료 시 */
                                info.width = "350px";
                                // info.height = "180px";
                                info.renewal = "RENEWAL";
                                info.contents = obj.$i18nUtil.trans("AG028", "비밀번호 유효기간이 만료되었습니다.\n비밀번호 재설정 후 다시 로그인해주세요.");
                                obj.handleDialog(info);
                            } else if(errorCode === "AUTH_NO_ACCESS_AUTH") {
                                info.contents = obj.$i18nUtil.trans("message.IntegrateLogin.009", "접근 권한이 없는 사용자 입니다.");
                                obj.handleDialog(info);
                            } else if(errorCode === "ERROR_NOT_FOUND_USER") {
                                info.contents = obj.$i18nUtil.trans("message.IntegrateLogin.010", "가입되지 않은 사용자입니다.");
                                obj.handleDialog(info);
                            } else if(errorCode === "AUTH_NO_HLI_DOMAIN") {
                                info.contents = obj.$i18nUtil.trans("message.IntegrateLogin.013", "한화생명 클레버스를 이용해주세요. https://cleverse.hanwhalife.com");
                                obj.handleDialog(info);
                            } else if(errorCode === "AUTH_NO_ADMISSION") {
                                info.contents = obj.$i18nUtil.trans("AG045", "가입이 신청되었습니다.\n관리자 승인 후 최종가입이 완료되며, 최종가입 완료 시 안내 메일이 발송됩니다.");
                                obj.handleDialog(info);
                            }
                        } else {
                            if (res.result != null) {
                                if(res.result.accessDevice !== undefined) {
                                    obj.accessDevice = res.result.accessDevice;
                                    obj.isCertification = true;
                                } else {
                                    let isIntro = res.result.isIntro;
                                    let isManager = res.result.isManager;
                                    let okrUse = res.result.okrUse;
                                    let accessType = res.result.accessType;
                                    localStorage.setItem("okrUse", okrUse);
                                    //let privacyAgreeYn = res.result.privacyAgreeYn;
                                    let userId = res.result.orgDeptUserView.userId;
                                    localStorage.setItem("isManager", isManager);
                                    localStorage.setItem("accessType", accessType);
                                    //localStorage.setItem("privacyAgreeYn", privacyAgreeYn);
                                    localStorage.setItem("userId", res.result.orgDeptUserView.userId);
                                    localStorage.setItem("tenantId", res.result.tenantId);
                                    localStorage.setItem("sharUse", res.result.sharUse);
                                    localStorage.setItem("cfrcUse", res.result.cfrcUse);
                                    localStorage.setItem("boardHashTagUse", res.result.boardHashTagUse);
                                    localStorage.setItem("boardAllListUse", res.result.boardAllListUse);
                                    localStorage.setItem("autoInvite", res.result.autoInvite);
                                    localStorage.setItem("i18nUse", res.result.i18nUse);
                                    localStorage.setItem("pinBlockYn", res.result.pinBlockYn);
                                    localStorage.setItem("announcementUseYn", res.result.announcementUseYn);
                                    // localStorage.setItem("orderListUse", res.result.orderListUse);
                                    // localStorage.setItem("orgMapUse", res.result.orgMapUse);
                                    
                                    obj.setDefaultLanguage(res.result.orgDeptUserView.defaultLanguage, res.result.tenantId);
                                    
                                    if(obj.$i18nUtil.getLanguage() === 'ko') {
                                        localStorage.setItem("userName", res.result.orgDeptUserView.userName);
                                        localStorage.setItem("deptName", res.result.orgDeptUserView.deptName);
                                    }else{
                                        localStorage.setItem("userName", res.result.orgDeptUserView.userNameEn);
                                        localStorage.setItem("deptName", res.result.orgDeptUserView.deptNameEn);
                                    }

                                    let returnUrl = localStorage.getItem("returnUrl");
                                    if (returnUrl != null &&
                                        returnUrl != "/" &&
                                        returnUrl != "/join") {
                                            obj.$router.push(returnUrl);
                                    } else {
                                        if(isIntro === false) {
                                            obj.$router.push("/general/intro");
                                        } else {
                                            obj.$router.push("/general/home");
                                        }
                                    }
                                }
                            }
                        }
                    })
                    .catch(function(err) {
                        console.log(err);
                    });
                }
            });
        },
        /* 비밀번호 재설정 */
        RenewalPasswordPop() {
            const modalInfo = {
                width: "500px",
                height: "591px",
                obj: this.$modal,
                component: UserCheck
            };
            this.showModal(modalInfo);
        },
        /* 인증번호 재전송 요청 시, 
         * 1) 앱 사용자: SMS/모바일 앱 선택 화면 (this.accessDevice === true) 
         * 2) 앱 미사용자: 화면 전환 없이 produceOtp 재호출 (this.accessDevice === false)
         **/
        reProduceOtp() {
            // if(this.accessDevice === false) {
            //     this.produceOtp();
            // }else {
            //     this.otpInputField = false
            // }

            // 2021-09-16 재전송 요청 시, 화면 전환 X & produceOtp 재호출로 수정
            this.produceOtp();
        },
        /* 인증번호 생성 */
        produceOtp() {
            // this.isFirst = false;
            let obj = this;
            let reqData = {
                url: "/api/auth/produceOtp",
                method: "post",
                params: {
                    otpId: obj.otpId,
                    userId: obj.userId,
                    certType : obj.type,
                    password: obj.password,
                    accessDevice : obj.accessDevice
                }
            };
            obj
            .COWORK_REST_SIMPLE_ACTION(reqData)
            .then(function(res) {
                if(res.errorCode !== null) {
                    let errorCode = res.errorCode;
                    if(errorCode === "NOT_EXIST_CELL_PHONE_NO") {
                        let info = {
                            title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                            contents: obj.$i18nUtil.trans("message.IntegrateLogin.011", "핸드폰 번호가 존재하지 않습니다."),
                            button: obj.$i18nUtil.trans("button.dialog.confirm", "확인")
                        };
                        obj.handleDialog(info);
                    }
                } else {
                    if (res.result.otpId != null) {
                        obj.otpInputField = true;
                        // console.log("OTP 번호 :: " + res.result.otp);
                        obj.isValidPw = true;
                        obj.resOtp = res.result.otp;
                        obj.otpId = res.result.otpId;
                        obj.time = 300;
                        obj.handleCountDown();

                        let info = {
                            title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                            contents: obj.$i18nUtil.trans("AG014", "인증번호가 전송되었습니다."),
                            button: obj.$i18nUtil.trans("button.dialog.confirm", "확인")
                        };
                        obj.handleDialog(info);
                    }
                }
            })
            .catch(function(err) {
                console.log(err);
            });
        },
        /* 인증번호 비교 및 로그인 */
        compareOtp() {
            if (this.time === 0) {
                let info = {
                    title: this.$i18nUtil.trans("title.dialog.notice", "알림"),
                    contents: this.$i18nUtil.trans("AG015", "인증번호 입력시간이 초과되었습니다.\n인증번호 재전송 후 다시 입력해주세요."),
                    button: this.$i18nUtil.trans("button.dialog.confirm", "확인")
                };
                this.handleDialog(info);
            } else {
                if (this.otp !== undefined && this.otp !== "") {
                    let obj = this;
                    let reqData = {
                        url: "/api/auth/compareOtp",
                        method: "post",
                        params: {
                            otp: obj.otp,
                            otpId: obj.otpId,
                            userId: obj.userId,
                            isLdap: obj.isLdap,
                            domain: obj.domain,
                        }
                    };
                    obj
                    .COWORK_REST_SIMPLE_ACTION(reqData)
                    .then(function(res) {
                    if (res.errorCode !== null) {
                        let errorCode = res.errorCode;
                        if (errorCode === "AG017") {
                            let info = {
                                title: obj.$i18nUtil.trans("title.dialog.notice", "알림"),
                                contents: obj.$i18nUtil.trans("AG017", "인증번호가 일치하지 않습니다.\n인증번호를 확인 후 다시 시도해주세요."),
                                button: obj.$i18nUtil.trans("button.dialog.confirm", "확인")
                            };
                            obj.handleDialog(info);
                        }
                    } else {
                        let userId = res.result.orgDeptUserView.userId;
                        let isManager = res.result.isManager;
                        let isIntro = res.result.isIntro;
                        let isInternalUser = res.result.isInternalUser;
                        let okrUse = res.result.okrUse;
                        localStorage.setItem("okrUse", okrUse);
                        if(res.result.privacyAgreeYn !== null) {
                            localStorage.setItem("privacyAgreeYn", res.result.privacyAgreeYn);
                        }
                        localStorage.setItem("tenantId", res.result.tenantId);
                        localStorage.setItem("userId", res.result.orgDeptUserView.userId);
                        localStorage.setItem("sharUse", res.result.sharUse);
                        localStorage.setItem("cfrcUse", res.result.cfrcUse);
                        localStorage.setItem("accessType", accessType);
                        localStorage.setItem("boardHashTagUse", res.result.boardHashTagUse);
                        localStorage.setItem("boardAllListUse", res.result.boardAllListUse);
                        localStorage.setItem("autoInvite", res.result.autoInvite);
                        localStorage.setItem("i18nUse", res.result.i18nUse);
                        localStorage.setItem("pinBlockYn", res.result.pinBlockYn);
                        localStorage.setItem("announcementUseYn", res.result.announcementUseYn);
                        // localStorage.setItem("orderListUse", res.result.orderListUse);
                        // localStorage.setItem("orgMapUse", res.result.orgMapUse);

                        obj.setDefaultLanguage(res.result.orgDeptUserView.defaultLanguage, res.result.tenantId);

                        if(obj.$i18nUtil.getLanguage() === 'ko') {
                            localStorage.setItem("userName", res.result.orgDeptUserView.userName);
                            localStorage.setItem("deptName", res.result.orgDeptUserView.deptName);
                        }else{
                            localStorage.setItem("userName", res.result.orgDeptUserView.userNameEn);
                            localStorage.setItem("deptName", res.result.orgDeptUserView.deptNameEn);
                        }
																 
                        let returnUrl = localStorage.getItem("returnUrl");
                        if (returnUrl != null &&
                            returnUrl != "/" &&
                            returnUrl != "/join") {
                                obj.$router.push(returnUrl);
                        } else {
                            if(isInternalUser) {
                                if(isIntro === false) {
                                    obj.$router.push("/general/intro");
                                } else {
                                    obj.$router.push("/general/home");
                                }
                            } else {
                                obj.$router.push("/general/home");
                            }
                        }
                    }
                    })
                    .catch(function(err) {
                    console.log(err);
                    });
                } else {
                    this.otpEmpty = true;
                    // 2021-09-09 인증번호 미입력 시, 팝업 -> 메시지 출력으로 변경
                    // let info = {
                    //     title: this.$i18nUtil.trans("title.dialog.notice", "알림"),
                    //     contents: this.$i18nUtil.trans("UB044", "인증번호를 입력해주세요."),
                    //     button: this.$i18nUtil.trans("button.dialog.confirm", "확인")
                    // };
                    // this.handleDialog(info);
                }
            }
        },
        /* 알림 Dialog */
        handleDialog(info) {
            const dialogInfo = {
                obj: this.$modal,
                component: Dialog,
                title : info.title,
                button : info.button,
                width : info.width,
                height : info.height,
                contents : info.contents,
                renewal : info.renewal
            };
            this.showDialog(dialogInfo);
        },
        dialogConfirm(info) {
            if(info.renewal === "RENEWAL") {
                this.RenewalPasswordPop();
            }
        },
        /* OTP 인증 만료 시간 */
        handleCountDown(timer) {
            if (timer !== null) {
                clearInterval(this.timer);
                this.timer = setInterval(() => {
                    if (this.time > 0) {
                        this.time--;
                    } else {
                        clearInterval(this.timer);
                    }
                }, 1000);
            } else {
                this.timer = setInterval(() => {
                    if (this.time > 0) {
                        this.time--;
                    } else {
                        clearInterval(this.timer);
                    }
                }, 1000);
            }
        },
        validOtp(params) {
            this.isModify = true;
            this.userId = params.userId;
            this.isValidOtp = params.isValidOtp;
            this.cellPhoneNo = params.cellPhoneNo;
            console.log(params);
        },
        successModify() {
            this.userId = "";
            this.password = "";
            this.isModify = false;
            this.isCertification = false;
        },
        isSsoCheck(){
            this.domain = location.host;
            if(this.domain.indexOf("hanwhalife.com") > -1 && this.domain != "cpdev.hanwhalife.com"){
                this.ssoUse = true;
                let ssoerrcd = this.checkSmError();
                if (ssoerrcd !== "") {
                    this.procSmEvent(ssoerrcd);
                }
            }
        },
        loginSSO() {
            this.$validator.validate().then(valid => {
                if(valid) {
                    let protectedPage = this.SMSSO_PROTECTED_PAGE;
                    if(location.host.indexOf("cpstg") > -1){
                        protectedPage = "http://eptest.hanwhalife.com:6080/HCPQA/api/auth/hcpsso/sso_protect";
                    }
                    let ssoLoginFcc = this.SMSSO_LOGIN_FCC;
                    if(location.host.indexOf("cpstg") > -1){
                        ssoLoginFcc = "http://eptest.hanwhalife.com:6080/siteminderagent/forms/login.fcc";
                    }
                    let smagentName = this.SMSSO_SMAGENTNAME;
                    if(location.host.indexOf("cpstg") > -1){
                        smagentName = "r12_sso_dev_agent";
                    }
                    let obj = this;
                    obj.$refs.SSO_LOGIN.method = 'POST';
                    obj.$refs.SSO_LOGIN.action = ssoLoginFcc;
                    obj.$refs.SSO_LOGIN.TARGET.value = protectedPage;
                    obj.$refs.SSO_LOGIN.SMAGENTNAME.value = smagentName;
                    obj.$refs.SSO_LOGIN.submit();
                }
            });
        },
        /**
         * 다국어 설정
         * 1. 사용자 설정값 없으면 browser language
         * 2. 제공 언어: ko, en
         * 3. 제공 언어 외 default: en
         **/ 
        setDefaultLanguage(language, tenantId) {     
            let locale = language;
            if (locale === null || locale === '') {
                locale = this.browserLocale;
            } else {
                locale = locale !== 'ko' ? 'en' : locale;
            }
 
            (tenantId === '418502' || tenantId === '428' || tenantId === '201' || tenantId === '203') ? locale += '-' + tenantId : "";
            this.$i18n.locale = locale;
            localStorage.setItem("defaultLanguage", locale);
        }
    }
};
</script>
<style scoped>
.input-box input:focus::placeholder{
    color:transparent;
    display: none;
}
input:focus::-webkit-input-placeholder {color:transparent; }
</style>


// WEBPACK FOOTER //
// src/components/cowork/login/integrate/IntegrateReLogin.vue